// src/components/ListSearch.js
import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { Link } from 'react-router-dom';
import FilterForm from './filterForm';
import './listSearch.css';
import { jwtDecode } from 'jwt-decode';
import DashboardNavbar from '../components/Navbar/navbar-dashboard';
import NavigationBar from '../components/Navbar/navbar';
import Footer from '../components/Footer/footer';
import SearchIcon from '../images/home-landing-page/search-icon.png';
import BoxLogo from '../images/home-landing-page/box-logo.png';
import BlueCheckMark from '../images/home-landing-page/blue-checkmark.png';
import StarRating from '../components/StarRating/startRating';
import Loader from '../components/Loader';

const useQuery = () =>
{
  return new URLSearchParams(useLocation().search);
};

const ListSearch = () =>
{
  const query = useQuery();
  const searchTermFromQuery = query.get('searchTerm');
  const postCodeFromQuery = query.get('postCode');

  const [searchTerm, setSearchTerm] = useState(searchTermFromQuery || '');
  const [postCode, setPostCode] = useState(postCodeFromQuery || '');
  const MAX_RESULTS = 20;
  const [professionResults, setProfessionResults] = useState([]); // For profession search results
  const [results, setResults] = useState([]); // To store the search results

  const [professionids, setProfessionIds] = useState([]);
  const [accreditations, setAccreditations] = useState([]);
  const [certifications, setCertifications] = useState([]);
  const [username, setUsername] = useState('');
  const navigate = useNavigate();
  const [showFilters, setShowFilters] = useState(false);
  const [sortOption, setSortOption] = useState("");
  const [sortedData, setSortedData] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);

  const keywordRef = useRef(null);
  const accreRef = useRef(null);
  const scopeRef = useRef(null);
  const ratingRef = useRef(null);
  const FullFilterRef = useRef(null);
  const [KeyWordDd, setKeyWordDd] = useState(false);
  const [AccreDd, setAccreDd] = useState(false);
  const [ScopeDd, setScopeDd] = useState(false);
  const [RatingDd, setRatingDd] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});
  const [loading, setLoading] = useState(false);
  const [activeConversation, setActiveConversation] = useState(null);
  const [userType, setUserType] = useState(null);
  const [filters, setFilters] = useState({
    keywordSearch: '',
    within: '25km',
    selectedAccreditations: [],
    workScope: {},
    ratings: '',
    licensed: false,
    insured: false,
    options: {},
    postcode: ''
  });

  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [selectedBusiness, setSelectedBusiness] = useState(null);

  const [sliderUrl, setSliderUrl] = useState(null);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
    // ← add this!
  const [iframeLoaded, setIframeLoaded] = useState(false);


  /*
  const onTestSliderClick = (business) => {
    //const url = `http://localhost:3000/businessProfile?businessId=${business.businessId}`;
    const url = `http://localhost:3000/businessProfile?businessId=103`;
    setIframeLoaded(false);            // reset loader state
    setSliderUrl(url);
    setIsSliderOpen(true);
  };
  */

  // (optional) if you want to clear the URL when closed:
  const closeSlider = () => {
    setIsSliderOpen(false);
  };


  
  // Function to handle profile open
  const handleProfileOpen = (business) => {
      setSelectedBusiness(business);
      setIsProfileOpen(true);
  };
  
  // Function to handle profile close
  const handleProfileClose = () => {
      setIsProfileOpen(false);
      setSelectedBusiness(null);
  };


  const onTestSliderClick = (business) => {
    const url = `${window.location.origin}/businessProfile?businessId=${btoa(business.businessId)}`;


    //const url = `${window.location.origin}/businessProfile?businessId=103`;
    console.log("▶️ loading slider URL:", url);
    setIframeLoaded(false);
    setSliderUrl(url);
    setIsSliderOpen(true);

};


  useEffect(() =>
  {
    const token = localStorage.getItem('token');
    if (token !== null)
    {
      const decodeToken = jwtDecode(token);
      setUsername(decodeToken.UserName);
    }
    setIsExpanded(false);
    document.addEventListener('mousedown', handleClickOutside);
    return () => { document.removeEventListener('mousedown', handleClickOutside); };
  }, [username]);

  useEffect(() =>
  {
    const performSearchFromQuery = async () =>
    {
      if (searchTermFromQuery && postCodeFromQuery)
      {
        setLoading(true);
        try
        {
          const response = await axios.post(`${API_BASE_URL}/api/search/searchprofpostcode`, {
            searchTerm: searchTermFromQuery,
            postCode: postCodeFromQuery,
          });

          setResults(response.data.businesses);
          setSortedData(response.data.businesses);
          console.log(response.data.businesses);
          setProfessionIds(response.data.professions);
          setAccreditations(response.data.certifications);
          setSortOption('');
          //setCertifications(response.data.certifications);
          setCertifications(response.data.certifications);
          setShowSearchResults(true);

          console.log(response.data.certifications);
          console.log(response.data.businesses.certifications);

          const token = localStorage.getItem('token');
          if (token)
          {
            const decodeToken = jwtDecode(token);
            setUserType(decodeToken.UserType);
          }
        } catch (error)
        {
          console.error('Error performing search:', error);
        }
        setLoading(false);
      }
    };

    performSearchFromQuery();
  }, [searchTermFromQuery, postCodeFromQuery]);

  const handleClickOutside = (event) =>
  {
    if (keywordRef.current && !keywordRef.current.contains(event.target))
    { setKeyWordDd(false); }
    if (accreRef.current && !accreRef.current.contains(event.target))
    { setAccreDd(false); }
    if (scopeRef.current && !scopeRef.current.contains(event.target))
    { setScopeDd(false); }
    if (ratingRef.current && !ratingRef.current.contains(event.target))
    { setRatingDd(false); }
    if (FullFilterRef.current && !FullFilterRef.current.contains(event.target))
    { setShowFilters(false) }
  };


  const handleSearchChange = async (e) =>
    {
      const searchValue = e.target.value;
      setSearchTerm(searchValue);
    
      console.log("[Search Input] User typed:", searchValue);
    
      if (searchValue.length > 0)
      {
        try
        {
          const response = await axios.get(`${API_BASE_URL}/api/Search/searchprofessions?search=${searchValue}`);
          
          console.log("[API Response] Full profession results:", response.data);
    
          // Optional: check for missing keys
          response.data.forEach((item, index) => {
            if (!item?.id || !item?.type) {
              console.warn(`[Warning] Missing key fields in item at index ${index}:`, item);
            }
          });

          
    
          setProfessionResults(response.data.slice(0, MAX_RESULTS));
        } catch (error)
        {
          console.error('[Error] Fetching professions:', error);
        }
      } else
      {
        setProfessionResults([]);
      }
    };

  const handleFilterSearch = async (appliedFilters) =>
  {
    setLoading(true);
    try
    {
      const response = await axios.post(`${API_BASE_URL}/api/search/searchwithfilters`, {
        searchTerm: searchTerm,
        keywordSearch: appliedFilters.keywordSearch,
        postCode: appliedFilters.postcode || postCode,
        within: parseInt(appliedFilters.within, 10),
        workScope: appliedFilters.workScope,
        ratings: appliedFilters.ratings,
        options: appliedFilters.options,
        //selectedAccreditations: appliedFilters.selectedAccreditations,
      });
      console.log('filtereddata', response.data.businesses)
      setResults(response.data.businesses);
      setSortedData(response.data.businesses);
    } catch (error)
    {
      console.error('Error performing filter search:', error);
    }
    setLoading(false);
  };


  const handleSearchSubmit = async () =>
  {
    setResults([]);
    if (searchTerm && postCode)
    {
      setLoading(true);
      try
      {
        const response = await axios.post(`${API_BASE_URL}/api/search/searchprofpostcode`, {
          searchTerm,
          postCode,
        });

        if (response.data.businesses && response.data.businesses.length > 0)
        {

          setResults(response.data.businesses);
          setSortedData(response.data.businesses);
          //setLocations(response.data.locations);
          setProfessionIds(response.data.professions);
          setAccreditations(response.data.businesses.certifications);
          setSortOption('');

          console.log("Businesses found:", response.data);
        } else
        {
          setResults([]);
          console.log("No businesses found.");
        }

        setShowSearchResults(true);
      } catch (error)
      {
        console.error('Error fetching search results:', error);
        if (error.response && error.response.status === 404)
        {
          setResults([]);
        }
      }
      setLoading(false);
    }
  };

  const addItem = (item) =>
  {
    setSearchTerm(`${item.name}`);
    setProfessionResults([]);
  };

  const handlePostCodeChange = (e) =>
  {
    setPostCode(e.target.value);
  };

  const handleClear = () =>
  {
    setSearchTerm('');
    setProfessionResults([]);
  };

  const handleLoginClick = () =>
  {
    navigate('/login');
  };

  const handleSignupClick = () =>
  {
    navigate('/register-home-user');
  };

  const handleApplyFilters = (appliedFilters) =>
  {
    setFilters(appliedFilters);
    setPostCode(appliedFilters.postcode);
    handleFilterSearch(appliedFilters);
    setShowFilters(false);
  };

  const handleSortChange = async (event) =>
  {
    setLoading(true);
    const selectedOption = event.target.value;
    setSortOption(selectedOption);
    let sortedList = [...results];
    switch (selectedOption)
    {
      case 'nearest-distance':
        sortedList = sortedList.sort((a, b) => a.distance - b.distance);
        break;

      case 'highest-rating':
        sortedList = sortedList.sort((a, b) => b.overallRating - a.overallRating);
        break;

      case 'after-hours':
        sortedList = sortedList.filter(result => result.afterHours === 1);
        break;

      case 'week-ends':
        sortedList = sortedList.filter(result => result.weekends === 1);
        break;

      default:
        break;
    }
    setSortedData(sortedList);
    setLoading(false);
  };

  const handleToggle = (id) =>
  {
    setExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle the expanded state for the specific item
    }));
  };

  const handleMessageClick = async (e, business) =>
  {
    try
    {
      setLoading(true);
      const token = localStorage.getItem('token');
      if (token !== null)
      {
        const decodeToken = jwtDecode(token);
        const userId = decodeToken.nameid;
        const response = await axios.get(`${API_BASE_URL}/api/Chat/NewConversation?businessUserid=${business?.businessUserId}&homeUserId=${userId}`);

        if (response.status === 200)
        {
          const conversationData = response.data;
          localStorage.setItem('chatUserId', business?.businessUserId);
          setActiveConversation(conversationData);
          if (decodeToken.UserType === "Home")
          {
            navigate('/home_messages', { state: { conversationId: conversationData.conversationId } });
          } else if (decodeToken.UserType === "Business")
          {
            navigate('/business_messages', { state: { conversationId: conversationData.conversationId } });
          }
        }
      } else
      {
        navigate('/login');
      }
    } catch (error)
    {
      console.error(error);
    } finally
    {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Navbar at the top */}
      {username ? (<DashboardNavbar prefix={''} />) : (<NavigationBar handleLoginClick={handleLoginClick} handleSignupClick={handleSignupClick} prefix={''} />)}
      {loading ? <Loader /> : null}
      <section class="inner-page-banner">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <h1 class="banner-heading">SEARCH</h1>
              <div class="search-form search-form-without-filters">
                <div class="search-inputs">

                  <div class="location-input">
                    <label>Where</label>
                    <input
                      type="text"
                      value={postCode}
                      onChange={handlePostCodeChange}
                      placeholder="Postcode"
                    />
                  </div>

                  <div class="service-input">
                    <label>Who or what service is required</label>
                    <input
                      type="text"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      placeholder="Electrician or install air cond.."
                    />
                    {searchTerm ? (<button onClick={handleClear} className="clear-button">×</button>) : null}
                  
                    {professionResults.length > 0 && (
                          <ul className="dropdown-results">
                            {professionResults.map((item) => (
                              <li key={`${item.type}-${item.id}`} className="result-item"
                              onClick={() => addItem(item)}
                              style={{ cursor: 'pointer' }}
                              >
                                <div className="result-item-content">
                                  <span>{item.name} </span>
                                </div>
                              </li>
                            ))}
                          </ul>
                        )}
   

                  </div>
                </div>
                <div class="filter-search">
                  {/* <button onClick={() => setShowFilters(!showFilters)} className="filters-button filter-btn btn">
                    <img src={FilterIcon} /> <span>{showFilters ? 'Filters' : 'Filters'}</span>
                  </button>
                  <div ref={FullFilterRef} className={`filters-popup ${showFilters ? 'visible' : 'hidden'}`}>

                  </div> */}
                  <button type="button" onClick={handleSearchSubmit} class="search-btn btn">
                    <img src={SearchIcon} /> <span>Search</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Show Filters and Results Only After Search is Triggered */}
      {showSearchResults && (
        <div class="list-page-wrapper dashboard-home-owner">
          <div class="container">
            <div class="row">
              <div class="col-sm-12">
                <div class="list-page-inner">
                  {/* LHS */}
                  <div class="filter-box-left">
                    <h3>Filters</h3>
                    <div class="search-form">
                      <FilterForm
                        onApplyFilters={handleApplyFilters}
                        initialPostCode={filters.postcode == '' ? postCode : filters.postcode}
                        filters={filters} // Pass the current filters state to FilterForm
                        initaccreditations={accreditations} />
                    </div>
                  </div>

                  {/* RHS */}
                  <div class="list-result-rightWrapper">
                    <div class="list-switch-sort">
                      <Link to={`/map-search?searchTerm=${searchTerm}&postCode=${postCode}`} className="list-search-link">
                        Map Search
                      </Link>

                      <div class="sort-select filter-form">
                        <label>Sort By:</label>
                        <select class="input-field" onChange={handleSortChange} value={sortOption}>
                          <option value=''>Relevance</option>
                          <option value='nearest-distance'>Nearest distance</option>
                          <option value='highest-rating'>Highest Rating</option>
                          <option value='after-hours'>After hours</option>
                          <option value='week-ends'>Week Ends</option>
                        </select>
                      </div>
                    </div>
                    <div class="list-resultbox-wrapper">
                      {Array.isArray(results) && results.length === 0 ? (
                        <p>No results found.</p>
                      ) : (
                        sortedData.map((result, index) => (
                          <div key={index} class="list-result-box" 
                          style={{ 
                            backgroundColor: result.isHighlighted ? '#FFF8DC' : '#ebf5fb',
                            border: result.isSponsored ? 'solid 5px gold' : (result.isHighlighted ? 'double 3px navy' : 'solid 3px black'),
                            position: 'relative', // Ensure we can position the Sponsored label
                            padding: '10px' // Add some padding so the Sponsored label has space
                        }}
                    >
                        {/* Sponsored Label */}
                        {result.isSponsored && (
                            <div className="sponsored-label">
                                Sponsored
                            </div>
                        )}
                          
                            <div class="result-item">
                              <div class="left-info"><div class="box-topbar">

                                <div class="imgbox">
                                  <img src={BoxLogo} alt="" /></div>

                                <div className='result-data-text'>
                                  <h4>{result.businessName}</h4>
                                  <p class="map-address">{result.description}</p>

                                  <div class="review-hours">
                                    <div class="review-box">
                                      <StarRating ratings={result.overallRating} />
                                      {result.overallRating} (1)
                                    </div>
                                    <div class="mairow-wrap">
                                      {result.afterHours ? (<p class="hours">Open 24 hours</p>) : null}
                                    </div>
                                  </div>
                                  <div class="review-hours">
                                    <div class="review-box">
                                      {username ? (<p className='map-phone'><span>{result.phone ? `${result.phone}` : null}</span></p>) : null}
                                    </div>
                                    <div class="mairow-wrap">
                                      {result.distance === 0 ? <p class='distance-from'>Close Proximity</p> : (<p class="distance-from">{result.distance.toFixed(2)} km</p>)}
                                    </div>
                                  </div>
                                </div>
                              </div>

                                <div class="Job-box-description">
                                  <label class="desc-heading">{result.overview}</label>




                                  <ul class="job-desc-list">
                                      {result.certifications && result.certifications.map((data, index) => (
                                          <li key={index}>
                                              <img src={BlueCheckMark} alt="Certification" /> {data.name}
                                          </li> 
                                      ))}
                                  </ul>


                                  <div class="job-desc-data">
                                    {/* {result.businessProfileOverview?.description} */}
                                    {expandedItems[result.businessId] // Use the unique id of the result
                                      ? result.businessProfileOverview?.description
                                      : (result.businessProfileOverview?.description && result.businessProfileOverview.description !== ''
                                        ? `${result.businessProfileOverview.description.substring(0, 160)}...`
                                        : null)}
                                    {result.businessProfileOverview?.description ? (
                                      <a onClick={() => handleToggle(result.businessId)} style={{ cursor: 'pointer', color: '#0243A9' }}>
                                        {expandedItems[result.businessId] ? 'Read less' : 'Read more'}
                                      </a>
                                    ) : null}

                                    {/* {isExpanded
                                      ? result.businessProfileOverview?.description
                                      : (result.businessProfileOverview?.description && result.businessProfileOverview.description !== ''
                                        ? `${result.businessProfileOverview.description.substring(0, 160)}...`
                                        : null)} {result.businessProfileOverview?.description ? (
                                          <a onClick={handleToggle} style={{ cursor: 'pointer', color: 'blue' }}>
                                            {isExpanded ? 'Read less' : 'Read more'}
                                          </a>
                                        ) : null} */}
                                  </div>
                                </div>

                              </div>
                              <div class="right-button-group">
                                <a class="button view-profile-btn" href={`/businessProfile?businessId=${btoa(result.businessId)}`} target="_blank" >View Profile</a>
                                
                                <button 
                                    className="button view-profile-btn" 
                                    onClick={() => onTestSliderClick(result)}
                                >
                                    Test Slider
                                </button>       

                                {/* <button class="button invite-job-btn">Get a quote</button> */}
                                {userType == 'Home' ? (<button class="button message-now-btn" onClick={(e) => handleMessageClick(e, result)}>Message</button>) : ''}
                                {userType !== null ? (<button class="button call-now-btn">Call Now</button>) : ''}
                              </div>
                            </div>
                          </div>




                        ))
                      )}
{/* Overlay and Sliding Panel */}
{isSliderOpen && (
  <div className={`profile-slider ${isSliderOpen ? 'open' : ''}`} style={{ transition: 'transform 2.5s ease-in-out' }}>
    <div className="profile-slider-header">
      <button onClick={() => setIsSliderOpen(false)}>Close</button>
    </div>

    {sliderUrl && (
      <>
        {/* show spinner until iframe loads */}
        {!iframeLoaded && <div className="spinner">Loading…</div>}

        <iframe
          src={sliderUrl}
          title="Business Profile"
          onLoad={() => setIframeLoaded(true)}
          style={{
            visibility: iframeLoaded ? 'visible' : 'hidden',
            width: '100%',
            height: '100%',
            border: 'none',
          }}
        />
      </>
    )}
  </div>
)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>)}

      <Footer />
    </div>
  );
};

export default ListSearch;
